module.exports = __webpack_public_path__ + "img/crossIcon.e140c0f9.svg";